import { render, staticRenderFns } from "./BusinessContactCompanyEdit.vue?vue&type=template&id=51316f0f"
import script from "./BusinessContactCompanyEdit.vue?vue&type=script&lang=js"
export * from "./BusinessContactCompanyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports